import { getUserDetails, isAdminUser } from "../../services/authService";
import { DEV_VIEW_MODE_STORAGE_KEY, VIEW_MODES } from "./constants";

function normalizeRole(value) {
  return String(value || "").trim().toLowerCase();
}

/**
 * Derive presentation mode from the real authenticated session (production SSOT).
 * @returns {import("./constants").ViewMode}
 */
export function resolveAuthViewMode() {
  if (isAdminUser()) return "admin";

  const user = getUserDetails();
  if (!user || typeof user !== "object") return "customer";

  const userType = normalizeRole(user.usertype ?? user.userType);
  if (userType === "agents" || userType === "agent") return "agent";

  return "customer";
}

export function isValidViewMode(value) {
  return VIEW_MODES.includes(value);
}

export function readStoredDevViewMode() {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(DEV_VIEW_MODE_STORAGE_KEY);
    return isValidViewMode(raw) ? raw : null;
  } catch {
    return null;
  }
}

export function writeStoredDevViewMode(mode) {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(DEV_VIEW_MODE_STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}
